module.exports = __webpack_public_path__ + "static/media/menuDinner.439683d9.png";